import { create } from 'zustand';
import { IMeetingNotificationStore } from './types';

export const useMeetingNotificationStore = create<IMeetingNotificationStore>(
  (set, get) => ({
    meeting: null,
    addMeeting: (meeting) => set({ meeting: meeting }),
    removeMeeting: (meeting) => {
      if (!meeting) {
        set({ meeting: null });
        return;
      }
      if (meeting.chatId !== get().meeting?.chatId) return;
      set({ meeting: null });
    },
  }),
);
